// extracted by mini-css-extract-plugin
export default {"card":"ReportCard_card__Od1rJ","innerCard":"ReportCard_innerCard__-2Tjf","btn":"ReportCard_btn__YewaG","bordered":"ReportCard_bordered__LZqEf"};